import { ace_index } from '@axo/shared/data-access/types';
import { send } from '../../lib/send';
import { IAPI } from '../../lib/models/api';

export function findWorkingList({ url: { service: baseURL }, token }: IAPI) {
  return function find(audience?: ace_index.Audience) {
    const search = new URLSearchParams();

    audience?.ClientIDs?.forEach((id) => search.set('clientID', id));
    audience?.Roles?.forEach((role) => search.set('role', role));
    audience?.MarketCountries?.forEach((country) =>
      search.set('marketCountry', country),
    );

    return send<void, ace_index.WorkingList[]>({
      baseURL,
      token,
      path: `/ace-index/working-list?${search.toString()}`,
      method: 'GET',
    });
  };
}

export function createWorkingList({ url: { service: baseURL }, token }: IAPI) {
  return (workingList: ace_index.WorkingList): Promise<ace_index.WorkingList> =>
    send({
      baseURL,
      token,
      path: `/ace-index/working-list`,
      method: 'POST',
      body: workingList,
    });
}

export function updateWorkingList({ url: { service: baseURL }, token }: IAPI) {
  return (workingList: ace_index.WorkingList): Promise<void> =>
    send({
      baseURL,
      token,
      path: `/ace-index/working-list/${workingList.ID}`,
      method: 'PUT',
      body: workingList,
    });
}

export function removeWorkingList({ url: { service: baseURL }, token }: IAPI) {
  return (id: string) =>
    send<void, void>({
      baseURL,
      token,
      path: `/ace-index/working-list/${id}`,
      method: 'DELETE',
    });
}
